import { Inject, InjectionToken, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'qPointTranslateUnit',
  standalone: true,
  pure: false
})
export class QPointTranslateUnitPipe implements PipeTransform {

  constructor(
    @Inject(DI_UNIT_TRANSLATIONS_BASE_PATH) private basePath: string,
    private translate: TranslateService
  ) { }

  public transform(sign: string): string {
    if (!sign) {
      return null;
    }
    const toTranslate = this.basePath.concat(sign);
    const translation = this.translate.instant(toTranslate);
    return (translation && translation.replace(toTranslate, '').length > 0)
      ? translation : sign;
  }
}

export const DI_UNIT_TRANSLATIONS_BASE_PATH = new InjectionToken<string>('QPointUnitTranslationsBasePath');
